var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97461 2.25C10.0628 2.25 10.1228 2.2771 10.1729 2.32715C10.2229 2.3772 10.25 2.43723 10.25 2.52539C10.2499 3.52942 10.0314 4.52403 9.59082 5.51074C9.15 6.49786 8.52425 7.39795 7.71094 8.21094C6.89762 9.02393 5.99754 9.64966 5.01074 10.0908C4.0244 10.5317 3.02973 10.7503 2.02539 10.75C1.93723 10.75 1.8772 10.7229 1.82715 10.6729C1.7771 10.6228 1.75 10.5628 1.75 10.4746V8.4502C1.75 8.40562 1.76316 8.36434 1.80176 8.31934C1.84243 8.27198 1.89446 8.23689 1.96484 8.21582L3.66504 7.87109C3.74081 7.86099 3.82078 7.8686 3.90723 7.89551C3.99718 7.92353 4.05782 7.96114 4.09863 8.00195L5.40918 9.3125L5.5752 9.2168C5.90161 9.02782 6.21136 8.819 6.50391 8.59082C6.79452 8.36414 7.07123 8.11768 7.33594 7.85352L7.33691 7.85449C7.61911 7.58084 7.87811 7.29586 8.11426 7C8.35247 6.70154 8.55866 6.39081 8.73242 6.06836L8.82031 5.90527L8.69043 5.77441L7.47754 4.54883L7.47656 4.54785C7.44108 4.51228 7.41693 4.47175 7.40332 4.42188C7.38968 4.37188 7.38427 4.29401 7.39844 4.18066L7.39746 4.17969L7.7207 2.44531L7.72168 2.43848C7.72833 2.39524 7.74922 2.35305 7.80078 2.30859C7.82485 2.28785 7.84851 2.27305 7.87305 2.26367L7.95117 2.25H9.97461Z",
    fill: "#1B2F3F",
    stroke: "#403C6F",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.77d115b6db7568255cd96c0ded5a63f3.svg";
export { ForwardRef as ReactComponent };